import { render } from "./AddAssetToStoryboxDropdown.vue?vue&type=template&id=fc16c28a&ts=true"
import script from "./AddAssetToStoryboxDropdown.vue?vue&type=script&lang=ts"
export * from "./AddAssetToStoryboxDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__